import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../index.css";
import { getOpeningTimes } from "../api";

function Footer() {
    const [times, setTimes] = useState([]);

    useEffect(() => {
        getOpeningTimes()
            .then(setTimes)
            .catch(() => setTimes([]));
    }, []);

    const dayMap = { MONDAY: "Mo", TUESDAY: "Di", WEDNESDAY: "Mi", THURSDAY: "Do", FRIDAY: "Fr", SATURDAY: "Sa", SUNDAY: "So" };
    const display = times.length
        ? times.map(t => {
            const range = t.hasLunchBreak && t.afternoonOpen && t.afternoonClose
                ? `${t.open}–${t.close}, ${t.afternoonOpen}–${t.afternoonClose}`
                : `${t.open}–${t.close}`;
            return `${dayMap[t.dayOfWeek] || t.dayOfWeek.substring(0,2)}: ${range}`;
        }).join(" | ")
        : "Keine Zeiten hinterlegt";

    return (
        <footer className="bg-gray-900 text-white p-6 text-center w-full mt-auto">
            <p>© 2025 Autoservice Groß GmbH</p>
            <p className="text-sm mt-1">
                Tannenkircher Straße 2a, 79415 Bad Bellingen, Germany | 07635 1845 |{" "}
                <a href="mailto:info@ford-gross.de" className="text-blue-500 hover:underline">
                    info@ford-gross.de
                </a>
            </p>
            <p className="text-sm mt-1">Öffnungszeiten: {display}</p>
            <p className="text-sm mt-1">
                <Link to="/impressum" className="text-blue-500 hover:underline">
                    Impressum
                </Link>
            </p>
        </footer>
    );
}

export default Footer;
